import { alpha, createTheme } from '@mui/material/styles';

const ink = '#172033';
const sand = '#f4efe7';
const paper = '#fbf8f3';
const copper = '#9b6b3d';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: { main: ink },
    secondary: { main: copper },
    background: {
      default: sand,
      paper,
    },
    text: {
      primary: ink,
      secondary: '#5f6878',
    },
    success: { main: '#2f6f57' },
    warning: { main: '#a66a2c' },
    error: { main: '#b4443b' },
    divider: alpha(ink, 0.1),
  },
  shape: {
    borderRadius: 16,
  },
  typography: {
    fontFamily: '"IBM Plex Sans", "Segoe UI", sans-serif',
    h4: {
      fontWeight: 600,
      letterSpacing: '-0.03em',
    },
    h5: {
      fontWeight: 600,
      letterSpacing: '-0.02em',
    },
    h6: {
      fontWeight: 600,
      letterSpacing: '-0.01em',
    },
    button: {
      fontWeight: 600,
      textTransform: 'none',
    },
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: alpha(paper, 0.92),
          backdropFilter: 'blur(14px)',
          color: ink,
          boxShadow: 'none',
          borderBottom: `1px solid ${alpha(ink, 0.08)}`,
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: '#f8f3eb',
          borderRight: `1px solid ${alpha(ink, 0.08)}`,
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          backgroundColor: paper,
          border: `1px solid ${alpha(ink, 0.08)}`,
          boxShadow: '0 18px 40px rgba(23, 32, 51, 0.06)',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 999,
          paddingInline: 16,
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 999,
          fontWeight: 600,
        },
      },
    },
    MuiDataGrid: {
      styleOverrides: {
        root: {
          border: 'none',
          '--DataGrid-containerBackground': paper,
          '--DataGrid-rowBorderColor': alpha(ink, 0.06),
        },
        columnHeaders: {
          backgroundColor: alpha(ink, 0.02),
          borderBottom: `1px solid ${alpha(ink, 0.08)}`,
        },
        cell: {
          borderBottom: `1px solid ${alpha(ink, 0.05)}`,
        },
      },
    },
  },
});

export default theme;
